import Model from "~/models/_Model";
import Session from "./Session";
import ScanLog from "./ScanLog";
import Scannable from "./Scannable";
import { useDayjs } from '#dayjs';
import relativeTime from "dayjs/plugin/relativeTime";
const dayjs = useDayjs();
dayjs.extend(relativeTime);

export default class TimeEvent extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/scanning";
  }

  // Set the resource route of the model
  resource() {
    return "time-events";
  }

  relations() {
    return {
      session: Session,
      time_in_scan: ScanLog,
      time_out_scan: ScanLog,
      scannable: Scannable,
    };
  }

  get is_open_time_event() {
    return this.time_out_scan_id == null;
  }

  get display_status() {
    return this.is_open_time_event ? "In" : "Out";
  }

  get display_processed_at() {
    if (!this.processed_at) {
      return "";
    }
    return dayjs(this.processed_at)
      .local()
      .format("ddd, DD MMM YYYY hh:mm:ss A");
  }

  get display_status_icon() {
    switch (this.status) {
      case "Error":
        return "error";
      default:
        return "check";
    }
  }

  get display_status_color() {
    switch (this.status) {
      case "Running":
        return "positive";
      case "Error":
        return "negative";
      default:
        return "info";
    }
  }

  get display_active_icon() {
    return this.active ? "check" : "error";
  }

  get display_active_color() {
    return this.active ? "positive" : "negative";
  }

  get display_last_run() {
    if (!this.last_run) {
      return "";
    }
    const last_run = dayjs(this.last_run);
    return `${last_run.format(
      "MM/DD/YYYY @ h:mm:ss A"
    )} (${last_run.fromNow()})`;
  }

  get display_next_run() {
    if (!this.next_run) {
      return "";
    }
    const next_run = dayjs(this.next_run);
    return `${next_run.format(
      "MM/DD/YYYY @ h:mm:ss A"
    )} (${next_run.fromNow()})`;
  }
}
